
export default function StreamerRecruitment() {
  const requirements = [
    {
      icon: 'ri-twitter-x-fill',
      title: 'Active on X (Twitter)',
      description: 'Maintain an active presence and engage with the crypto community',
      color: 'emerald',
      link: 'https://x.com/pfunicoin'
    },
    {
      icon: 'ri-live-fill',
      title: 'Stream Pump.fun Weekly',
      description: 'Stream about Pump.fun content at least once per week',
      color: 'purple'
    },
    {
      icon: 'ri-team-fill',
      title: 'Community Engagement',
      description: 'Actively participate and engage with the PSU community',
      color: 'emerald'
    }
  ];

  const handleApplyClick = () => {
    window.open('https://pump.fun/', '_blank');
  };

  const handleRequirementClick = (requirement: any) => {
    if (requirement.link) {
      window.open(requirement.link, '_blank');
    }
  };

  return (
    <section className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/5 to-purple-500/5"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-emerald-400 mb-8">
            Streamer Recruitment Hub
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-400 to-emerald-400 mx-auto mb-8"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Ready to join the elite ranks of PSU streamers? Here's what we're looking for in our next class of creators.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {requirements.map((req, index) => (
            <div key={index} className="group relative">
              <div 
                className={`bg-gradient-to-br from-slate-800/50 to-slate-900/50 p-8 rounded-3xl border border-gray-700/50 hover:border-emerald-500/30 transition-all duration-300 hover:transform hover:scale-105 h-full ${req.link ? 'cursor-pointer' : ''}`}
                onClick={() => handleRequirementClick(req)}
              >
                <div className={`w-16 h-16 bg-gradient-to-br ${req.color === 'emerald' ? 'from-emerald-500/20 to-emerald-600/20' : 'from-purple-500/20 to-purple-600/20'} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${req.icon} text-2xl ${req.color === 'emerald' ? 'text-emerald-400' : 'text-purple-400'}`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{req.title}</h3>
                <p className="text-gray-300 leading-relaxed">{req.description}</p>
                {req.link && (
                  <div className="flex items-center text-emerald-400 font-medium mt-4 group-hover:text-emerald-300 transition-colors">
                    <span>Visit Profile</span>
                    <i className="ri-external-link-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-slate-800/30 to-slate-900/30 rounded-3xl p-12 border border-gray-700/30">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-white mb-6">Ready to Apply?</h3>
            <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
              Join hundreds of successful streamers who have already made PSU their home. Start your journey today!
            </p>
            
            <button
              onClick={handleApplyClick}
              className="group inline-flex items-center px-10 py-5 text-lg font-bold text-white bg-gradient-to-r from-purple-600 to-emerald-600 rounded-full hover:from-purple-500 hover:to-emerald-500 transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-purple-500/25 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-fill mr-3 text-xl"></i>
              Submit Application
              <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>

            <div className="mt-8 flex flex-wrap justify-center gap-6 text-sm text-gray-400">
              <div className="flex items-center">
                <i className="ri-time-line mr-2 text-emerald-400"></i>
                <span>Quick 5-min application</span>
              </div>
              <div className="flex items-center">
                <i className="ri-shield-check-line mr-2 text-purple-400"></i>
                <span>Verified streamers only</span>
              </div>
              <div className="flex items-center">
                <i className="ri-rocket-line mr-2 text-emerald-400"></i>
                <span>Fast approval process</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
